<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container v-if="!loading" class="py-10 py-md-13 py-lg-16">
        <div v-if="item.title">
          <TitleWidget class="text-center">
            {{ item.title }}
          </TitleWidget>

          <div
            v-if="item.text"
            class="grey--text text--darken-1 text-body-1 text-center mt-4"
          >
            {{ item.text }}
          </div>

          <BusinessSedimentSection />

          <CoprocessedWasteSection />
        </div>

        <v-alert v-else type="info" width="100%">
          Nenhum conteúdo adicionado até o momento.
        </v-alert>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import BusinessSedimentSection from "../components/sections/BusinessSedimentSection.vue";
import CoprocessedWasteSection from "../components/sections/CoprocessedWasteSection.vue";

const _config = {
  mod: "sedimentAbout",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    BusinessSedimentSection,
    CoprocessedWasteSection,
  },
};
</script>
